module.exports = __webpack_public_path__ + "static/media/google.41bc99f2.svg";